<template>
    <div class="question">
        <div class="question-body">
            <div class="container py-3">
                <div class="question-topic" v-if="topic && subject">
                    Тема: {{ topic.title }},
                    <span style="display: inline-block">Раздел: {{ subject.title }}</span>
                </div>
                <div class="question-text" v-if="question.question">
                    {{ question.question }}
                </div>

                <div class="question-image mt-2" v-if="question.image">
                    <img :src="question.image" :alt="question.question">
                </div>
            </div>
        </div>

        <div class="answers">
            <answer
                v-for="answer in answers"
                v-bind:key="answer.id"
                :answer="answer"
                :state="getAnswerState(answer)"
                @selected="emitSelected"
                :checked="currentAnswer && currentAnswer.id === answer.id"
                :disabled="disabled"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            topic: {
                required: false,
            },
            subject: {
                required: false,
            },
            question: {
                required: true,
                type: Object,
            },
            disabled: {
                required: false,
                type: Boolean,
                default() {
                    return false
                }
            },
            answerState: {
                required: false,
                type: String,
            },
            answer: {
                required: false,
                type: Object,
            },
            showCorrect: {
                required: false,
                type: Boolean,
                default() {
                    return false;
                }
            },
            randomAnswers: {
                required: false,
                type: Boolean,
                default() {
                    return false;
                }
            },
        },

        data() {
            return {
                currentAnswer: this.answer,
            }
        },

        computed: {
            answers() {
                if (this.randomAnswers) {
                    return this.question.answers.slice().sort(() => 0.5 - Math.random());
                }

                return this.question.answers;
            }
        },

        methods: {
            emitSelected(answer) {
                this.currentAnswer = answer;
                this.$emit('selectedAnswer', answer);
            },

            resetCurrentAnswer() {
                this.currentAnswer = null;
            },

            getAnswerState(answer) {
                if (this.showCorrect && answer.isCorrect) {
                    return 'correct';
                }

                return this.currentAnswer && this.currentAnswer.id === answer.id ? this.answerState : null
            }
        },

        watch: {
            answer(value) {
                this.currentAnswer = value
            }
        }
    }
</script>